import Int32LookupModelBase from '../_generated/modelBases/int32-lookup-model-base';

export default class Int32LookupModel extends Int32LookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
